import * as React from 'react';
import { connect } from 'react-redux';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

import { __t } from 'utils/language';
import {
  NAME_MAX_LENGTH,
  isRequired,
  maxLength
} from 'utils/validators';
import { getInputOnChangeHandler } from '../../utils';

import type {
  CcmCampaignFormCreatorlessDispatch as Dispatch,
  StateAsPartOfGlobal
} from '../../types';

type OwnProps = {
  mgsKey: string,
  className: string
};

type StateProps = {
  name: string
};

type DispatchProps = {
  onChangeName: (n: string) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const Name = ({
  className,
  mgsKey,
  name,
  onChangeName
}: Props): JSX.Element => (
  <FormField
    showRequiredMark
    showValidationIcon={false}
    fontSize="small"
    label={__t(`${mgsKey}.name.label`)}
    sublabel={__t(`${mgsKey}.name.sublabel`)}
    labelType="highlighted"
    direction="column"
    validators={[
      isRequired(name),
      maxLength(name, NAME_MAX_LENGTH)
    ]}
  >
    <div className={className}>
      <Input
        name="name"
        width="responsive"
        value={name}
        placeholder={__t(`${mgsKey}.name.placeholder`)}
        data={{ identifier: 'name' }}
        onChange={getInputOnChangeHandler(onChangeName)}
      />
    </div>
  </FormField>
);

const mapStateToProps = ({ ccmCampaignFormCreatorless }: StateAsPartOfGlobal): StateProps => ({
  name: ccmCampaignFormCreatorless.form.name
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onChangeName: name => dispatch({ type: 'creatorless-campaign-name-update', payload: { name } })
});

export default connect(mapStateToProps, mapDispatchToProps)(Name);
